export default __webpack_public_path__ + "static/media/exito1.b3ecd92a.png";